import { Model, modelRegistry } from './Model';
import { Product } from '.';
import HashGen from '../utilities/HashGen';
export class WarehouseTransferItem extends Model {
    static entity = 'warehouse_transfer_items';
    id = null;
    warehouse_transfer_id = null;
    product_id = null;
    product_name = null;
    product_code = null;
    count = '1.000';
    created_at = null;
    updated_at = null;
    hash = '';
    static fields() {
        return {
            id: this.attr(null),
            warehouse_transfer_id: this.attr(null),
            product_id: this.attr(null),
            product_name: this.attr(null),
            product_code: this.attr(null),
            count: this.attr('1.000', value => this.round(value, 3).toFixed(3)),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            hash: this.attr(HashGen.regular()),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    getCount() {
        return parseFloat(this.count);
    }
    /** Live product from the models store; falls back to the snapshot columns for display. */
    getProduct() {
        return Product.find(this.product_id);
    }
    getProductName() {
        return this.getProduct()?.name || this.product_name || '';
    }
    getProductCode() {
        return this.getProduct()?.code || this.product_code || '';
    }
    getUnitOfMeasure() {
        return this.getProduct()?.getUnitOfMeasure() || '';
    }
}
export default WarehouseTransferItem;
modelRegistry.register('WarehouseTransferItem', WarehouseTransferItem);
//# sourceMappingURL=WarehouseTransferItem.js.map